import { createAsyncThunk } from "@reduxjs/toolkit";
import { v4 as uuid } from "uuid";

import { type SurveyTemplateWithCreator } from "@fitness-app/data-models/entities/SurveyTemplate";

import { type AsyncThunkCreator } from "../../../index";
import { SURVEYS_TEMPLATES_REDUCER_NAME } from "../types";
import { fetchSurveysTemplates } from "./fetchSurveysTemplates";

type Payload = {
  survey: SurveyTemplateWithCreator;
};

export const duplicateSurveyTemplate = createAsyncThunk<void, Payload, AsyncThunkCreator<string>>(
  `${SURVEYS_TEMPLATES_REDUCER_NAME}/duplicateSurveyTemplate`,
  async ({ survey }, { rejectWithValue, dispatch, getState, extra: { db, analytics } }) => {
    const { data: userData } = getState().user;
    const { creator, ...rest } = survey;

    const duplicatedSurvey = {
      ...rest,
      id: uuid(),
      title: `${rest.title} (Kopia)`,
      createdBy: userData?.id || rest.createdBy,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };

    const { error } = await db.from("survey_template").insert(duplicatedSurvey);

    if (error) {
      return rejectWithValue(error.message);
    }

    analytics.track("duplicate_survey_template");

    void dispatch(fetchSurveysTemplates());
  },
);
